import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModelInvoice } from 'src/app/entities/invoices';
import { UTILS } from 'src/app/entities/Utils';
import { Address, AddressElement, AddressInfo, GenericResponse } from 'src/app/entities/various';
import { ConfigServiceService, ItemSelectProps } from 'src/app/services/config-service/config-service.service';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { UserData } from 'src/app/services/login/login.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { UserService } from 'src/app/services/users/user.service';
import { RicercaIndirizzoComponent } from '../dialog/ricerca-indirizzo/ricerca-indirizzo.component';
import { Address as AddressHelper } from 'src/app/entities/Address';
import { SoggettiDestinatarioComponent } from './soggetti-destinatario/soggetti-destinatario.component';
import { SharedServiceService } from 'src/app/services/shared/shared-service.service';


@Component({
  selector: 'app-soggetti',
  templateUrl: './soggetti.component.html',
  styleUrls: ['./soggetti.component.css']
})
export class SoggettiComponent implements OnInit, OnChanges {
  innerWidth: number | undefined = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  
  @Input() model! : ModelInvoice | undefined;
  @Input() userInfo! : UserData | undefined;
  @Output() modelChange = new EventEmitter<ModelInvoice>();
  @Output() validaCedenteCessionario = new EventEmitter<any>();
  @Input() easyMode! : boolean;
  @Input() ValidaCedenteCessionarioEvent : any;

  public addressHelper=new AddressHelper();

  public configTabs = {
    selected: 1,
    config: [
      {
        id: 1, 
        name: "invoices.edit.entities.other.tabs.tab1",
        ricerca_indirizzo: {type: "C", description: "Cedente/prestatore"},
        selectedChild: '1_1',
        children: [
          {id: '1_1', name: "invoices.edit.entities.other.tabs.tab1_1", isMandatory:true},
          {id: '1_2', name: "invoices.edit.entities.other.tabs.tab1_2", isMandatory:true},
          {id: '1_3', name: "invoices.edit.entities.other.tabs.tab1_3", isMandatory:false},
          {id: '1_4', name: "invoices.edit.entities.other.tabs.tab1_4", isMandatory:false},
          {id: '1_5', name: "invoices.edit.entities.other.tabs.tab1_5", isMandatory:false},
          {id: '1_6', name: "invoices.edit.entities.other.tabs.tab1_6", isMandatory:false}
        ],
        isMandatory:true
      },
      {
        id: 2,
        name: "invoices.edit.entities.other.tabs.tab2",
        ricerca_indirizzo: {type: "D", description: "Cessionario committente"},
        selectedChild: "2_1",
        children: [
          {id: '2_1', name: "invoices.edit.entities.other.tabs.tab2_1", isMandatory:true},
          {id: '2_2', name: "invoices.edit.entities.other.tabs.tab2_2", isMandatory:false},
          {id: '2_3', name: "invoices.edit.entities.other.tabs.tab2_3", isMandatory:false},
        ], 
        isMandatory:true
      },
      {
        id: 3,
        name: "invoices.edit.entities.other.tabs.tab3",
        ricerca_indirizzo: {type: "R", description: "Rappresentante"},
        selectedChild: 1,
        children: [],
        isMandatory:false
      },
      {
        id: 4,
        name: "invoices.edit.entities.other.tabs.tab4",
        ricerca_indirizzo: {type: "T", description: "Terzo"},
        selectedChild: 1,
        children: [],
        isMandatory:false
      }
    ]
  }

  viewDetail: boolean = true;

  regimi : ItemSelectProps[] = [];
  soci : ItemSelectProps[] = [] ;
  liq : ItemSelectProps[] = [];
  isDestinatarioEstero: boolean = false;
  isMittenteEstero: boolean = false;

  isDestinatarioPresente: boolean = true;
  isMittentePresente: boolean = false;
  selezionaCedente: boolean = false;

  constructor(private configService: ConfigServiceService, 
    private modalService: NgbModal, 
    private configurationServices: ConfigurationService,
    private userService: UserService,
    private toastService: ToastService,
    private sharedService: SharedServiceService
  ) {
    this.innerWidth = window.innerWidth;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.model){
      this.model = changes.model.currentValue;
    }

    if(changes.easyMode){
      this.restoreForm();
    }

    if(changes.ValidaCedenteCessionarioEvent){
      this.controlloDestEstero();
      this.controlloMittenteEstero();
    }

  }


  async ngOnInit() {
    let list = (await this.configService.getJSON()).list;
    this.regimi = list.listRegimeFiscale;
    let finalList: ItemSelectProps[] = [];
    finalList.push({val: "", label: " "})
    list.listSocioUnico.forEach(e => finalList.push(e));
    this.soci = finalList;
    this.liq = list.listStatoLiquidazione;
    if(this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese!="IT") {
      if(this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese.length==2) {
        this.isDestinatarioEstero=true;
      }
    }
      
    if(this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese!="IT") {
      if(this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese.length==2) {
           this.isMittenteEstero=true;
      }
    }

    this.sharedService.isDestinatarioPresente$.subscribe(valore => {
      //this.isDestinatarioPresente = valore;
      this.selezionaCedente = valore;
    });
    
  }

  public getChild(idTab: number) : {id: string, name: string,isMandatory:boolean}[]{
    return this.configTabs.config.filter(i => i.id == idTab)[0].children;
  }

  public setSelectedChild(idParent: number, idChild: string){
    return this.configTabs.config.filter(i => i.id == idParent)[0].selectedChild = idChild;
  }

  public isSelectedChild(idParent: number, idChild: string){
    return this.configTabs.config.filter(i => i.id == idParent)[0].selectedChild == idChild;
  }

  public compilaAutofattura() {
    this.sharedService.setDestinatarioPresente(true);
    this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici = new UTILS().deepCopy(this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici);
    this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede = new UTILS().deepCopy(this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede);
    this.model!.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = '2C1PNCW';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.iban = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.CAP = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Comune = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Indirizzo = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Nazione = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.NumeroCivico = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Provincia = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.RegimeFiscale = 'RF01';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.ProvinciaAlbo = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.NumeroIscrizioneAlbo = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdCodice = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.DataIscrizioneAlbo = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.CodiceFiscale = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.AlboProfessionale = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.CodEORI = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.CodiceUnivoco = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Cognome = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Denominazione = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Nome = '';
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.PEC = undefined;
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.PersonaFisica = 0;
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Titolo = '';

    this.model!.FatturaElettronicaHeader.SoggettoEmittente = 'CC';

    delete this.model!.FatturaElettronicaHeader.TerzoIntermediarioOSoggettoEmittente;

    this.validaCedenteCessionario.emit();
    
  }

  public async inserisciDestinatario() {
    let modalRef = this.modalService.open(SoggettiDestinatarioComponent, {size: 'xl'});
    let response : any = await modalRef.result.then(result => {return result;}).catch(err => {return null});

    if(response){
      if (!this.selezionaCedente) {
        this.isDestinatarioPresente = true;
        this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Denominazione = (response.denominazione.length > 0 ? response.denominazione : response.nome + ' ' + response.cognome);
        this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese = response.id_paese;
        this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdCodice = (response.partita_iva.length > 0 ? response.partita_iva : '');
        this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale = response.codice_fiscale;
        this.model!.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = (response.codice_destinatario != '') ? response.codice_destinatario : "0000000";
        if (response.pec != '') {
          this.model!.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario = response.pec;
        }
        this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Indirizzo = response.indirizzo;
        this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.NumeroCivico = response.civico;
        this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.CAP = response.cap;
        this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Comune = response.comune;
        this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Provincia = response.provincia;
        this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Nazione = response.nazione;
      } else {
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Denominazione = (response.denominazione.length > 0 ? response.denominazione : response.nome + ' ' + response.cognome);
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese = response.id_paese;
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdCodice = (response.partita_iva.length > 0 ? response.partita_iva : '');
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.CodiceFiscale = response.codice_fiscale;
        this.model!.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = (response.codice_destinatario != '') ? response.codice_destinatario : "0000000";
        this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Indirizzo = response.indirizzo;
        this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.NumeroCivico = response.civico;
        this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.CAP = response.cap;
        this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Comune = response.comune;
        this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Provincia = response.provincia;
        this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Nazione = response.nazione;
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.RegimeFiscale = "RF01";
      }

      if (response.codice_destinatario.length == 7) {
        this.model!.FatturaElettronicaHeader.DatiTrasmissione.FormatoTrasmissione = "FPR12";
      } else {
        this.model!.FatturaElettronicaHeader.DatiTrasmissione.FormatoTrasmissione = "FPA12";
      }


      /*let data = await this.configurationServices.getAddressById(this.userInfo!.user_id, response.id);
      
      if(data.success){
        let infoUser : any = new UTILS().deepCopy(data.data.data);
        this.isDestinatarioPresente = true;

        this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici = infoUser.DatiAnagrafici;
        this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale = infoUser.RappresentanteFiscale;
        this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede = infoUser.Sede;

        this.model!.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario = infoUser.DatiAnagrafici.Anagrafica.PEC ? infoUser.DatiAnagrafici.Anagrafica.PEC : (data.data.email_pec ? data.data.email_pec : "");
        this.model!.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = infoUser.DatiAnagrafici.Anagrafica.CodiceUnivoco ? infoUser.DatiAnagrafici.Anagrafica.CodiceUnivoco as string : "";
      }*/
        
      this.controlloDestEstero();
      this.controlloMittenteEstero();
    }
  }

  public toUpperCaseAndSubstitute(denominazione: string) {
    const chars: any = {
      'à': 'a',
      'è': 'e',
      'é': 'e',
      'ì': 'i',
      'ò': 'o',
      'ù': 'u'
    }
    return (denominazione).replace(/[àèéìòù]/g, m => chars[m]).toLocaleUpperCase();
  }

  public checkPersonaFisica(event: any){
    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.PersonaFisica = event.target.checked ? 1 : 0;
    if(this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.PersonaFisica == 1){
      this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Denominazione = "";
    } else {
      this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Cognome = "";
      this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Nome = "";
      this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Titolo = "";
    }
  }

  public checkPersonaFisicaDest(event: any){
    this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.PersonaFisica = event.target.checked ? 1 : 0;
    if(this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.PersonaFisica == 1){
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Denominazione = "";
    } else {
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Cognome = "";
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Nome = "";
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Titolo = "";
    }
  }

  public checkPersonaFisicaDestRap(event: any){
    this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.PersonaFisica = event.target.checked ? 1 : 0;
    if(this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.PersonaFisica == 1){
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.Denominazione = "";
    } else {
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.Cognome = "";
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.Nome = "";
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.Titolo = "";
    }
  }
  
  public checkPersonaFisicaRapFisc(event: any){
    this.model!.FatturaElettronicaHeader.RappresentanteFiscale.DatiAnagrafici.Anagrafica.PersonaFisica = event.target.checked ? 1 : 0;
    if(this.model!.FatturaElettronicaHeader.RappresentanteFiscale.DatiAnagrafici.Anagrafica.PersonaFisica == 1){
      this.model!.FatturaElettronicaHeader.RappresentanteFiscale.DatiAnagrafici.Anagrafica.Denominazione = "";
    } else {
      this.model!.FatturaElettronicaHeader.RappresentanteFiscale.DatiAnagrafici.Anagrafica.Cognome = "";
      this.model!.FatturaElettronicaHeader.RappresentanteFiscale.DatiAnagrafici.Anagrafica.Nome = "";
      this.model!.FatturaElettronicaHeader.RappresentanteFiscale.DatiAnagrafici.Anagrafica.Titolo = "";
    }
  }
  
  public checkPersonaFisicaIntermediario(event: any){
    this.model!.FatturaElettronicaHeader.TerzoIntermediarioOSoggettoEmittente!.DatiAnagrafici.Anagrafica.PersonaFisica = event.target.checked ? 1 : 0;
    if(this.model!.FatturaElettronicaHeader.TerzoIntermediarioOSoggettoEmittente!.DatiAnagrafici.Anagrafica.PersonaFisica == 1){
      this.model!.FatturaElettronicaHeader.TerzoIntermediarioOSoggettoEmittente!.DatiAnagrafici.Anagrafica.Denominazione = "";
    } else {
      this.model!.FatturaElettronicaHeader.TerzoIntermediarioOSoggettoEmittente!.DatiAnagrafici.Anagrafica.Cognome = "";
      this.model!.FatturaElettronicaHeader.TerzoIntermediarioOSoggettoEmittente!.DatiAnagrafici.Anagrafica.Nome = "";
      this.model!.FatturaElettronicaHeader.TerzoIntermediarioOSoggettoEmittente!.DatiAnagrafici.Anagrafica.Titolo = "";
    }
  }

  // Ricerca Indirizzo
  public async ricercaIndirizzo(idTab: number){
    let type = this.configTabs.config.filter(i => i.id == idTab)[0].ricerca_indirizzo;
    
    if(idTab==1){
      let val=this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento;
      if( val=="TD16" || val=="TD17" || val=="TD18" || val=="TD19")
          type = this.configTabs.config.filter(i => i.id == 2)[0].ricerca_indirizzo;
    }
    // let type = this.configTabs.config.filter(i => i.id == idTab)[0].ricerca_indirizzo;
    let modalRef = this.modalService.open(RicercaIndirizzoComponent, {size: 'lg'});
    modalRef.componentInstance.type = new UTILS().deepCopy(type);
    let response : AddressInfo | undefined = await modalRef.result.then(result => {return result;}).catch(err => {return null});
    if(response){
      //console.log(response);
      switch(this.configTabs.config.filter(c => c.id == idTab)[0].name){
        case "invoices.edit.entities.other.tabs.tab1":
          let iscrizioneRea = await (await this.userService.getNewUser()).data.sdi_data.IscrizioneREA;
          let dataCed = await this.configurationServices.getAddressById(this.userInfo!.user_id, response.id);
          if(dataCed.success){
            let infoUser : any = new UTILS().deepCopy(dataCed.data.data);
            infoUser.IscrizioneREA = iscrizioneRea;
            
            this.model!.FatturaElettronicaHeader.CedentePrestatore = infoUser;
            this.model!.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario = infoUser.DatiAnagrafici.Anagrafica.PEC ? infoUser.DatiAnagrafici.Anagrafica.PEC : "";
            //this.model!.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = infoUser.DatiAnagrafici.Anagrafica.CodiceUnivoco ? infoUser.DatiAnagrafici.Anagrafica.CodiceUnivoco as string : "";
          }
          break;
        case "invoices.edit.entities.other.tabs.tab2":
          let data = await this.configurationServices.getAddressById(this.userInfo!.user_id, response.id);
          
          if(data.success){
            let infoUser : any = new UTILS().deepCopy(data.data.data);
            //this.model!.FatturaElettronicaHeader.CessionarioCommittente = infoUser; MANCA LA PROPRIETA' STABILE ORGANIZZAZIONE
            this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici = infoUser.DatiAnagrafici;
            this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale = infoUser.RappresentanteFiscale;
            this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede = infoUser.Sede;

            this.model!.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario = infoUser.DatiAnagrafici.Anagrafica.PEC ? infoUser.DatiAnagrafici.Anagrafica.PEC : (data.data.email_pec ? data.data.email_pec : "");
            this.model!.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = infoUser.DatiAnagrafici.Anagrafica.CodiceUnivoco ? infoUser.DatiAnagrafici.Anagrafica.CodiceUnivoco as string : "";
          }
          break;
        
        case "invoices.edit.entities.other.tabs.tab3":
          let dataRapp = await this.configurationServices.getAddressById(this.userInfo!.user_id, response.id);
          if(dataRapp.success){
            let infoUser = new UTILS().deepCopy(dataRapp.data.data);
            this.model!.FatturaElettronicaHeader.RappresentanteFiscale = infoUser;

          }
          this.model!.FatturaElettronicaHeader.RappresentanteFiscale = JSON.parse(response.json_data);
          break;

        case "invoices.edit.entities.other.tabs.tab4":
          let dataTerz = await this.configurationServices.getAddressById(this.userInfo!.user_id, response.id);
          if(dataTerz.success){
            let infoUser = new UTILS().deepCopy(dataTerz.data.data);
            this.model!.FatturaElettronicaHeader.TerzoIntermediarioOSoggettoEmittente = infoUser;
            
          }
          this.model!.FatturaElettronicaHeader.TerzoIntermediarioOSoggettoEmittente = JSON.parse(response.json_data);
          break;
      }
      this.controlloDestEstero();
      this.controlloMittenteEstero();
    }
  }


  public notifyChange(){
    this.modelChange.emit(this.model);
  }

  public async salvaInRubrica(){
    let check = true;
    let response : GenericResponse;
    
    // controllo che non manchino i campi
    // denominazione/nome e cognome
    let anagrafica = this.model!.FatturaElettronicaHeader.CessionarioCommittente;
    if (anagrafica.DatiAnagrafici.Anagrafica.PersonaFisica == 0) {
      if (anagrafica.DatiAnagrafici.Anagrafica.Denominazione == "") {
        this.toastService.openToastWithConfig(true, 5000, "Denominazione mancante", "warning");
        check = false;
      }
    } else if (anagrafica.DatiAnagrafici.Anagrafica.Nome == "" && anagrafica.DatiAnagrafici.Anagrafica.Cognome == "") {
      this.toastService.openToastWithConfig(true, 5000, "Nome e cognome mancante", "warning");
      check = false;
    }

    if (anagrafica.DatiAnagrafici.IdFiscaleIVA.IdCodice != "" && anagrafica.DatiAnagrafici.IdFiscaleIVA.IdPaese == "") {
      this.toastService.openToastWithConfig(true, 5000, "Partita IVA inserita ma codice paese mancante", "warning");
      check = false;
    }

    // sede
    if (anagrafica.Sede.Indirizzo == "") {
      this.toastService.openToastWithConfig(true, 5000, "Indirizzo mancante", "warning");
      check = false;
    }
    if (anagrafica.Sede.Comune == "") {
      this.toastService.openToastWithConfig(true, 5000, "Citta' mancante", "warning");
      check = false;
    }
    if (anagrafica.Sede.CAP == "") {
      this.toastService.openToastWithConfig(true, 5000, "CAP mancante", "warning");
      check = false;
    }
    if (anagrafica.Sede.Provincia == "") {
      this.toastService.openToastWithConfig(true, 5000, "Provincia mancante", "warning");
      check = false;
    }
    if (anagrafica.Sede.Nazione == "") {
      this.toastService.openToastWithConfig(true, 5000, "Nazione mancante", "warning");
      check = false;
    }

    if (check) {
      let address: Address
      address = await (await this.configurationServices.getNewAddress()).data;
      
      // comporre l'oggetto address da passare
      address.data!.DatiAnagrafici.CodiceFiscale = anagrafica.DatiAnagrafici.CodiceFiscale;
      
      address.data!.DatiAnagrafici.Anagrafica.PersonaFisica = anagrafica.DatiAnagrafici.Anagrafica.PersonaFisica;
      if (address.data!.DatiAnagrafici.Anagrafica.PersonaFisica == 0) {
        (address.data!.DatiAnagrafici.Anagrafica.Denominazione = anagrafica.DatiAnagrafici.Anagrafica.Denominazione);
      } else {
        (address.data!.DatiAnagrafici.Anagrafica.Nome = anagrafica.DatiAnagrafici.Anagrafica.Nome);
        (address.data!.DatiAnagrafici.Anagrafica.Cognome = anagrafica.DatiAnagrafici.Anagrafica.Cognome);
      }
      address.data!.DatiAnagrafici.Anagrafica.CodiceUnivoco = this.model!.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario;
      address.data!.DatiAnagrafici.IdFiscaleIVA.IdPaese = anagrafica.DatiAnagrafici.IdFiscaleIVA.IdPaese;
      address.data!.DatiAnagrafici.IdFiscaleIVA.IdCodice = anagrafica.DatiAnagrafici.IdFiscaleIVA.IdCodice;

      // sede
      address.data!.Sede.Indirizzo = anagrafica.Sede.Indirizzo;
      address.data!.Sede.NumeroCivico = anagrafica.Sede.NumeroCivico;
      address.data!.Sede.Comune = anagrafica.Sede.Comune;
      address.data!.Sede.CAP = anagrafica.Sede.CAP;
      address.data!.Sede.Provincia = anagrafica.Sede.Provincia;
      address.data!.Sede.Nazione = anagrafica.Sede.Nazione;

      address.codice_fiscale = anagrafica.DatiAnagrafici.CodiceFiscale;
      address.email_pec = this.model!.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario;

      response = await this.configurationServices.salvaIndirizzo(this.userInfo!.user_id, address);
     // console.log(response);
      if(response && response.success) {
        if(response.error!=null)
          this.toastService.openToastWithConfig(true, 5000, response.error, "error");  
        else
          this.toastService.openToastWithConfig(true, 5000, "Salvataggio effettuato con successo", "success");
      } else {
        this.toastService.openToast(response.msg, "warning");
        
      }
    }
    
  }

  public isEasyMode(){
    return this.easyMode;
  }

  private restoreForm(){
      if(!this.easyMode) return;
      this.configTabs.selected=1;
      this.configTabs.config[0].selectedChild = '1_2';
      this.configTabs.config[1].selectedChild = '2_1';

      this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.CodEORI=""
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.CodEORI=""
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Titolo="";

      this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Titolo="";
      
      this.notifyChange();
  }

  public checkVatFormat(value :string,event :Event){
    let elm=(event.target as HTMLInputElement);
    if(elm.dataset.country!= undefined){
      if(elm.dataset.country =="IT"){
      return value.replace(/[^0-9]/g,"");    
      }
    }
    return value.toLocaleUpperCase();
  }

  private validateVat(vat :string,country:string){
    if(country=="") return false;
    if(country=="IT"){
          if(vat.length==11) return true;
          return false;
    }
    return true;
  }

    public isValidVat(vat :string,country:string, fiscalCode? :string,isPhysical? :number){
      if(isPhysical !=undefined){
        if(isPhysical==1){
            //persona privata, solo cf...
            if((fiscalCode!.length >= 11 ) && country=="" && vat.length==0)
                  return true;

            //piva, paese obbligatori, standard.
            if(country=="") return false;
            if(country=="IT"){
                  if(vat.length==11) return true;
                  return false;
            }
            return true;
        }else{
            //potrebbe essere anche una associazione
            if(fiscalCode=="")
              return this.validateVat(vat,country);

            if((country!="IT") && (country!="")) return true;

            if((/^\d+$/.test(fiscalCode as string)) && (fiscalCode?.length==11) ){
                  //numerica, di 11 caratteri.
                  if((/^\d+$/.test(vat)) || ((vat == "") && (country == "")))
                      return true;
            }
            return false;
        }
      }
      return this.validateVat(vat,country);
    }



  public idPaeseFormat(inp :string){
    return inp.replace(/[^a-zA-Z]/g,"").toLocaleUpperCase();
  }


  public controlloDestEstero(){
   // console.log(this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese);
    if((this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese.length==2) && (this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese!="IT")){
          this.isDestinatarioEstero=true;
          this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdCodice == '' ? '999999999' : this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdCodice;
          this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale="";
          this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Nazione=this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese;
          this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Provincia=this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese;
          this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.CAP='00000';
          this.model!.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario='XXXXXXX';
    }else{
        this.isDestinatarioEstero=false;
    }
  }

  public controlloMittenteEstero(){
    if((this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese.length==2) && (this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese!="IT")){
      this.isMittenteEstero=true;
      this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdCodice == '' ? '999999999' : this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdCodice;
      this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.CodiceFiscale="";
      this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Nazione=this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese;
      this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Provincia=this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese;
      this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.CAP='00000';
    }else{
        this.isMittenteEstero=false;
    }
  }




  //aggiungere controllo in cedente prestatore per isValidVat agg. parametri in coda fiscalCode,isPhysical
  //cf associazione pò essere diverso da p iva.... 
  
  public checkFiscalCodeFormat(fiscalCode :string,country:string,isPhysical :number)
  {
    if(country!="IT") return true;
    if(fiscalCode=="") return true;
    if(isPhysical==1){
        let re = new RegExp('^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$');
        return re.test(fiscalCode);
    }else{
        //let re= new RegExp('^[0-9]{11}$');
        //return re.test(fiscalCode);
        return true;
    }
  }

}
